// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oO_8","navbar":"footer_navbar__2_D0h","navbarContent":"footer_navbarContent__3ejHW","text":"footer_text__1Raz6"};